/* ===== Artist Push — Cart v2 behaviour (07.2026) =====
   Self-contained. Talks to /cart/*.js AJAX API by line-item key.
   The discount app on this store SPLITS same-variant lines and REGENERATES
   line keys on every change, so: (a) after every mutation the item list is
   re-rendered from the Section Rendering API response, (b) the pending
   (soft-removed) row is tracked by variant id, not only by key, and (c) a
   missed removal is retried once against the fresh key. EU-27 visitors get
   the express-consent checkout wording. Legacy bridges kept in sync:
   #CartSubtotal (menu.js observer -> #total-value, eSputnik widget),
   #cart-count-value, .header__cart-active. */

(function () {
  'use strict';

  var root = document.querySelector('.ap-cart');
  if (!root) return;

  var form = document.getElementById('cart');
  if (!form) return; // empty cart page

  var symbol = root.getAttribute('data-currency-symbol') || '$';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var sectionId = root.closest('[data-section-id]') ? root.closest('[data-section-id]').getAttribute('data-section-id') : root.getAttribute('data-section-id');
  var itemsWrap = document.getElementById('ap-cart-items');
  var toast = document.getElementById('ap-toast');
  var toastUndo = document.getElementById('ap-toast-undo');
  var linkBlock = document.getElementById('ap-link-block');
  var linkInput = document.getElementById('ap-cart-link');
  var linkInvalid = document.getElementById('ap-link-invalid');

  function money(cents) {
    return symbol + (cents / 100).toFixed(2);
  }

  function postForm(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams(data).toString()
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    var data = { id: key, quantity: quantity };
    if (sectionId) data.sections = sectionId;
    return postForm(ROOT + 'cart/change.js', data);
  }

  /* 27.10.2026: текст під Total залежить від кошика і від реальної знижки (відсоток беремо з discount applications, не з константи).
     1 позиція → запрошення на другу; 2 позиції при увімкненому тирі → «ще один = 10% на все»; інакше → «{pct} discount applied». */
  function renderUpsellMsg(upsell, cart, pctParts) {
    if (!upsell || !cart) return;
    upsell.querySelectorAll('[data-one]').forEach(function (el) {
      var tier = parseInt(el.getAttribute('data-tier') || '0', 10) || 0;
      var t;
      if (cart.item_count === 1) t = el.getAttribute('data-one');
      else if (cart.item_count === 2 && tier > 0 && el.getAttribute('data-two')) t = el.getAttribute('data-two');
      else t = el.getAttribute('data-many');
      if (t) el.innerHTML = t.replace('__PCT__', pctParts.length ? pctParts.join(' + ') : '5%');
    });
  }

  /* Percent hint next to the "Discount" label, read from the discount's own
     configuration (value_type=percentage). Shopify puts DISCOUNT CODES in
     cart_level_discount_applications but allocates AUTOMATIC product/BXGY
     discounts (our "5%OFF") per line in line_level_discount_allocations, so
     both places must be scanned — otherwise the percent stays empty on load. */
  function updateDiscountPct(cart) {
    var pctEl = document.getElementById('ap-discount-pct');
    if (!pctEl || !cart) return [];
    var parts = [];

    function consider(da, shown) {
      if (!da || !shown) return;
      if (da.value_type !== 'percentage') return;
      var v = Math.round(parseFloat(da.value));
      if (v > 0 && parts.indexOf(v + '%') === -1) parts.push(v + '%');
    }

    /* the row shows codes always; automatic discounts only for 2+ item carts */
    function isShown(da) {
      return da.type === 'discount_code' || cart.item_count >= 2;
    }

    (cart.cart_level_discount_applications || []).forEach(function (da) {
      consider(da, isShown(da) && da.total_allocated_amount > 0);
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var da = alloc.discount_application || {};
        consider(da, isShown(da) && alloc.amount > 0);
      });
    });

    pctEl.textContent = parts.length ? ' (' + parts.join(' + ') + ')' : '';
    return parts;
  }

  /* ===== Totals sync ===== */
  function syncTotals(cart) {
    var subtotalEl = document.getElementById('ap-subtotal');
    var discountRow = document.getElementById('ap-discount-row');
    var discountVal = document.getElementById('ap-discount-value');
    var totalEl = document.getElementById('total-value');
    var countEl = document.getElementById('cart-count-value');
    var bridge = document.getElementById('bk-cart-subtotal-price');
    var badge = document.querySelector('.header__cart-active');

    /* Discount row shows code discounts always; automatic (app) discounts only
       for 2+ item carts — the upsell automation stays visible, single-item
       auto discounts are folded into the subtotal (mirrors the Liquid render) */
    var codeDiscount = 0;
    (cart.cart_level_discount_applications || []).forEach(function (da) {
      if (da.type === 'discount_code') codeDiscount += da.total_allocated_amount;
    });
    var autoDiscount = cart.total_discount - codeDiscount;
    if (autoDiscount < 0) autoDiscount = 0;
    /* auto discounts stay visible for 2+ items (upsell automation), hidden for single-item carts */
    var visibleDiscount = codeDiscount + (cart.item_count >= 2 ? autoDiscount : 0);
    var hiddenAuto = cart.total_discount - visibleDiscount;
    if (hiddenAuto < 0) hiddenAuto = 0;
    if (subtotalEl) subtotalEl.textContent = money(cart.original_total_price - hiddenAuto);
    if (discountRow) {
      if (visibleDiscount > 0) {
        discountRow.hidden = false;
        if (discountVal) discountVal.textContent = '−' + money(visibleDiscount);
      } else {
        discountRow.hidden = true;
      }
    }
    updateDiscountPct(cart);
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count;
    if (badge) badge.textContent = cart.item_count;
    var wordEl = document.getElementById('ap-item-word');
    if (wordEl) {
      var w = wordEl.getAttribute(cart.item_count === 1 ? 'data-one' : 'data-many');
      if (w) wordEl.textContent = w;
    }
    /* Блок рекомендації: показуємо для 1–3 позицій. Текст: 1 позиція —
       «додай другу і отримай 5%», 2+ — «5% застосовано» (5%OFF = BXGY,
       одна позиція на замовлення), тексти лежать у data-one/data-many. */
    var upsell = document.getElementById('ap-upsell');
    if (upsell) {
      upsell.hidden = cart.item_count < 1 || cart.item_count > 3;
      upsell.classList.toggle('is-multi', cart.item_count >= 2);
      /* 27.10.2026: текст під Total залежить від кошика і від реальної знижки (відсоток беремо з discount applications, не з константи).
         1 позиція → запрошення на другу; 2 позиції при увімкненому тирі → «ще один = 10% на все»; інакше → «{pct} discount applied». */
      renderUpsellMsg(upsell, cart, updateDiscountPct(cart) || []);
    }
    /* menu.js MutationObserver watches #CartSubtotal and re-derives #total-value
       from it, so the bridge must always carry the payable total. */
    if (bridge) bridge.textContent = money(cart.total_price);
  }

  /* Replace the item rows with the server-rendered markup (source of truth for
     line splits/keys). Returns false when the response has no section HTML. */
  function renderLines(cart) {
    var html = cart && cart.sections && cart.sections[sectionId];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('ap-cart-items');
    if (!fresh) return false;
    itemsWrap.innerHTML = fresh.innerHTML;
    if (pending) {
      /* keep the pending (soft-removed) row hidden across re-renders; keys
         regenerate on every change on this store, so fall back to variant id */
      var pkey = pending.row.getAttribute('data-key');
      var pvariant = pending.row.getAttribute('data-variant');
      var again = itemsWrap.querySelector('.ap-cart-item[data-key="' + pkey + '"]')
        || itemsWrap.querySelector('.ap-cart-item[data-variant="' + pvariant + '"]');
      if (again) {
        again.classList.add('is-removing');
        pending.row = again;
      }
    }
    return true;
  }

  function syncLines(cart) {
    var rows = itemsWrap.querySelectorAll('.ap-cart-item');
    var used = {};
    rows.forEach(function (row) {
      /* Shopify regenerates the line-item key hash when quantity changes on
         this store (discount app rebuilds lines), so rows are matched by
         variant id — consuming each cart item once, because the same variant
         can appear on several lines — and data-key is refreshed. */
      var variant = row.getAttribute('data-variant');
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (!used[i] && String(cart.items[i].variant_id) === variant) { item = cart.items[i]; used[i] = true; break; }
      }
      if (!item) {
        if (!row.classList.contains('is-removing')) row.remove();
        return;
      }
      row.setAttribute('data-key', item.key);
      row.setAttribute('data-quantity', item.quantity);
      var input = row.querySelector('.ap-qty__value');
      if (input) input.value = item.quantity;
      var minus = row.querySelector('.ap-qty__btn--minus');
      if (minus) minus.disabled = item.quantity <= 1;
      var oldP = row.querySelector('.ap-cart-item__price-old');
      var curP = row.querySelector('.ap-cart-item__price-current');
      if (curP) curP.textContent = money(item.final_line_price);
      if (oldP) {
        /* old price = product compare-at (mirrors the Liquid render) */
        var compareAt = parseInt(row.getAttribute('data-compare-at'), 10) || 0;
        var oldLine = 0;
        if (compareAt > item.final_price) {
          oldLine = compareAt * item.quantity;
        } else if (item.original_line_price !== item.final_line_price) {
          oldLine = item.original_line_price;
        }
        if (oldLine > 0) {
          oldP.hidden = false;
          oldP.textContent = money(oldLine);
        } else {
          oldP.hidden = true;
        }
      }
    });
  }

  function syncAll(cart) {
    if (!renderLines(cart)) syncLines(cart);
    syncTotals(cart);
  }

  /* ===== Quantity stepper ===== */
  var lineQueues = {};

  function queueChange(row, quantity) {
    var qid = row.getAttribute('data-key');
    var prev = lineQueues[qid] || Promise.resolve();
    lineQueues[qid] = prev
      .then(function () {
        row.classList.add('is-updating');
        /* data-key is refreshed after every sync, read it at execution time */
        return changeLine(row.getAttribute('data-key'), quantity);
      })
      .then(function (cart) {
        row.classList.remove('is-updating');
        syncAll(cart);
        return cart;
      })
      .catch(function (err) {
        row.classList.remove('is-updating');
        console.error(err);
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(syncAll);
      });
    return lineQueues[qid];
  }

  itemsWrap.addEventListener('click', function (e) {
    var btn = e.target.closest('.ap-qty__btn');
    if (btn) {
      var row = btn.closest('.ap-cart-item');
      var input = row.querySelector('.ap-qty__value');
      var qty = parseInt(input.value, 10) || 1;
      var next = btn.classList.contains('ap-qty__btn--minus') ? qty - 1 : qty + 1;
      if (next < 1) return;

      /* optimistic UI; server response re-syncs everything */
      input.value = next;
      row.setAttribute('data-quantity', next);
      var minus = row.querySelector('.ap-qty__btn--minus');
      if (minus) minus.disabled = next <= 1;
      queueChange(row, next);
      return;
    }

    var removeBtn = e.target.closest('.ap-cart-item__remove');
    if (removeBtn) {
      var itemRow = removeBtn.closest('.ap-cart-item');
      softRemove(itemRow);
    }
  });

  /* ===== Soft remove + Undo toast ===== */
  var pending = null; // { row, timer }
  var TOAST_MS = 5000;

  function commitPending() {
    if (!pending) return Promise.resolve();
    var p = pending;
    pending = null;
    clearTimeout(p.timer);
    var variant = p.row.getAttribute('data-variant');
    return changeLine(p.row.getAttribute('data-key'), 0)
      .catch(function () {
        /* stale key (regenerated by the discount app while the removal was
           pending) — re-resolve the line by variant id and retry once */
        return fetch(ROOT + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var match = null;
            for (var i = 0; i < cart.items.length; i++) {
              if (String(cart.items[i].variant_id) === variant) { match = cart.items[i]; break; }
            }
            if (!match) return cart; /* already gone from the cart */
            return changeLine(match.key, 0);
          });
      })
      .then(function (cart) {
        p.row.remove();
        if (cart.item_count === 0) {
          window.location.reload();
          return cart;
        }
        syncAll(cart);
        return cart;
      })
      .catch(function (err) {
        console.error(err);
        p.row.classList.remove('is-removing');
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(syncAll);
      });
  }

  function optimisticTotalsAfterHide() {
    /* while the removal is pending, show totals as if the item is gone */
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hiddenKey = pending ? pending.row.getAttribute('data-key') : null;
        if (!hiddenKey) { syncTotals(cart); return; }
        var fake = JSON.parse(JSON.stringify(cart));
        var items = [];
        for (var i = 0; i < fake.items.length; i++) {
          var it = fake.items[i];
          if (it.key === hiddenKey) {
            fake.item_count -= it.quantity;
            fake.original_total_price -= it.original_line_price;
          } else {
            items.push(it);
          }
        }
        fake.items = items;
        /* cart-level discounts don't live on line prices here; approximate the
           discount proportionally (exact for percentage discounts) until the
           server response after commit/undo re-syncs the real numbers */
        if (cart.original_total_price > 0) {
          fake.total_discount = Math.round(cart.total_discount * fake.original_total_price / cart.original_total_price);
          (fake.cart_level_discount_applications || []).forEach(function (da) {
            da.total_allocated_amount = Math.round(da.total_allocated_amount * fake.original_total_price / cart.original_total_price);
          });
        }
        fake.total_price = fake.original_total_price - fake.total_discount;
        syncTotals(fake);
      });
  }

  function showToast() {
    /* fixed to the viewport bottom — visible without ever scrolling the page */
    toast.hidden = false;
    toast.classList.remove('is-hiding');
  }

  function hideToast() {
    toast.classList.add('is-hiding');
    setTimeout(function () {
      toast.hidden = true;
      toast.classList.remove('is-hiding');
    }, 200);
  }

  function softRemove(row) {
    /* a second removal while one is pending commits the previous one immediately */
    commitPending();

    row.classList.add('is-removing');
    pending = {
      row: row,
      timer: setTimeout(function () {
        hideToast();
        commitPending();
      }, TOAST_MS)
    };
    showToast();
    optimisticTotalsAfterHide();
  }

  toastUndo.addEventListener('click', function () {
    if (!pending) { hideToast(); return; }
    clearTimeout(pending.timer);
    pending.row.classList.remove('is-removing');
    pending = null;
    hideToast();
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(syncAll);
  });

  /* flush pending removal if the user leaves the page */
  window.addEventListener('pagehide', function () {
    if (!pending) return;
    var body = 'id=' + encodeURIComponent(pending.row.getAttribute('data-key')) + '&quantity=0';
    navigator.sendBeacon(
      ROOT + 'cart/change.js',
      new Blob([body], { type: 'application/x-www-form-urlencoded; charset=UTF-8' })
    );
    pending = null;
  });

  /* ===== Checkout: commit pending removal first, never block ===== */
  var checkoutInFlight = false;
  form.addEventListener('submit', function (e) {
    if (checkoutInFlight) return;
    if (!pending) return;
    e.preventDefault();
    checkoutInFlight = true;
    hideToast();
    commitPending().then(function () {
      var btn = document.getElementById('ap-checkout-btn');
      /* Запасний шлях для браузерів без requestSubmit (iOS ≤15): клік по справжній
         кнопці, а не form.submit() — інакше губиться name="checkout" (форма йде на
         /cart замість checkout) і не спрацьовують submit-обробники (згода, країна). */
      if (btn && form.requestSubmit) {
        form.requestSubmit(btn);
      } else if (btn) {
        btn.click();
      } else {
        form.submit();
      }
      checkoutInFlight = false;
    });
  });

  /* ===== EU-27 express-consent variant =====
     EU members only — no CH/NO/IS/LI/UK. Country detection chain: cached
     result -> cart attribute stored by the theme's own geo script (rendered
     into #CartJson) -> ipapi.co -> api.country.is (backup for ad-blockers and
     rate limits). Unknown country = default (non-EU) wording. */
  var EU_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

  function rememberCountry(c) {
    if (c) { try { sessionStorage.setItem('ap-country', c); } catch (e) { /* private mode */ } }
    return c;
  }

  function detectCountry() {
    try {
      var cached = sessionStorage.getItem('ap-country');
      if (cached) return Promise.resolve(cached);
    } catch (e) { /* private mode */ }
    try {
      var el = document.querySelector('script[id^="CartJson-"]');
      if (el) {
        var cartJson = JSON.parse(el.textContent);
        var attrs = cartJson.attributes || {};
        var c = attrs.country || attrs.Country;
        if (c) return Promise.resolve(rememberCountry(String(c)));
      }
    } catch (e) { /* fall through to the network lookup */ }
    return fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.country_code || null; })
      .catch(function () { return null; })
      .then(function (c) {
        if (c) return rememberCountry(c);
        /* backup source: ipapi.co is often ad-blocked or rate-limited */
        return fetch('https://api.country.is')
          .then(function (r) { return r.json(); })
          .then(function (d) { return rememberCountry(d.country || null); })
          .catch(function () { return null; });
      });
  }

  function applyEuVariant() {
    var btn = document.getElementById('ap-checkout-btn');
    if (btn && btn.getAttribute('data-label-eu')) {
      btn.textContent = btn.getAttribute('data-label-eu');
      /* sentence case per the EU mockup, not uppercase */
      btn.classList.add('ap-checkout-btn--eu');
    }
    var agreementDefault = document.getElementById('ap-agreement-default');
    var agreementEu = document.getElementById('ap-agreement-eu');
    if (agreementDefault) agreementDefault.hidden = true;
    if (agreementEu) agreementEu.hidden = false;
    /* evidence for disputes: express-consent flag lands in order attributes */
    form.addEventListener('submit', function () {
      var consent = document.getElementById('ap-eu-consent');
      if (!consent) {
        consent = document.createElement('input');
        consent.type = 'hidden';
        consent.id = 'ap-eu-consent';
        consent.name = 'attributes[eu_withdrawal_consent]';
        form.appendChild(consent);
      }
      consent.value = 'agreed-immediate-start ' + new Date().toISOString();
    });
  }

  /* Країна в замовлення: не фоновим POST при завантаженні (так було в inline-скрипті
     секції — зайвий запит і гонка з кнопкою), а прихованим полем attributes[country]
     у момент сабміту — той самий механізм, що й eu_withdrawal_consent. Невідома
     країна — поле не додається. Клієнт цього поля не бачить ні в кошику, ні в checkout;
     воно потрапляє лише в «Additional details» замовлення, як і раніше. */
  var detectedCountry = null;
  form.addEventListener('submit', function () {
    if (!detectedCountry) return;
    var field = document.getElementById('ap-country-field');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.id = 'ap-country-field';
      field.name = 'attributes[country]';
      form.appendChild(field);
    }
    field.value = detectedCountry;
  });

  detectCountry().then(function (country) {
    if (!country) return;
    detectedCountry = String(country).toUpperCase();
    if (EU_COUNTRIES.indexOf(detectedCountry) !== -1) {
      applyEuVariant();
    }
  });

  /* initial fill of the discount-percent hint from the server-rendered cart JSON */
  try {
    var cjInit = document.querySelector('script[id^="CartJson-"]');
    if (cjInit) { var cartInit = JSON.parse(cjInit.textContent); renderUpsellMsg(document.getElementById('ap-upsell'), cartInit, updateDiscountPct(cartInit) || []); }
  } catch (e) { /* noop */ }

  /* ===== Link to your content ===== */
  if (linkBlock && linkInput) {
    /* whole card focuses the input */
    linkBlock.addEventListener('click', function (e) {
      if (e.target === linkInput || e.target.closest('a')) return;
      linkInput.focus();
    });

    var URL_LIKE = /^(https?:\/\/)?[\w][\w.-]*\.[a-z]{2,}([\/?#]\S*)?$/i;

    /* Мʼяка підказка: показується під час ПАУЗИ в наборі (600 мс), ніколи на
       blur. На мобільному blur спрацьовує в момент тапу по кнопці checkout —
       рядок, що зʼявлявся під полем, зсував кнопку з-під пальця. Рядок
       #ap-link-invalid завжди займає місце (visibility, не display), тому
       нічого не стрибає. Валідація ніколи не блокує checkout. */
    var hintTimer = null;
    function setHint(on) {
      if (linkInvalid) linkInvalid.classList.toggle('is-on', !!on);
    }
    function validateSoft() {
      var v = linkInput.value.trim();
      setHint(v !== '' && !URL_LIKE.test(v));
    }

    /* Нотатка зберігається теж по input з паузою 500 мс; на blur — лише
       «дострілюємо» незбережене, з короткою затримкою, яку скасовує submit
       (форма і так несе note у своєму POST). */
    var noteTimer = null;
    var flushTimer = null;
    var submitting = false;
    var lastSavedNote = linkInput.value.trim();
    function saveNote(v) {
      if (v === lastSavedNote) return;
      lastSavedNote = v;
      postForm(ROOT + 'cart/update.js', { note: v })
        .catch(function (err) { lastSavedNote = null; console.error(err); });
    }

    linkInput.addEventListener('input', function () {
      setHint(false);
      clearTimeout(hintTimer);
      hintTimer = setTimeout(validateSoft, 600);
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { saveNote(linkInput.value.trim()); }, 500);
    });

    linkInput.addEventListener('blur', function () {
      clearTimeout(hintTimer);
      clearTimeout(noteTimer);
      clearTimeout(flushTimer);
      flushTimer = setTimeout(function () {
        if (!submitting) saveNote(linkInput.value.trim());
      }, 300);
    });

    form.addEventListener('submit', function () {
      submitting = true;
      clearTimeout(noteTimer);
      clearTimeout(flushTimer);
    }, true);

    /* bfcache («Назад» з checkout): форма може повернутись у стані submitting */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { submitting = false; setHint(false); }
    });
  }

  /* ===== Return to services ===== */
  var returnBtn = document.getElementById('ap-cart-return');
  if (returnBtn) {
    returnBtn.addEventListener('click', function () {
      var cameFromSite = document.referrer && document.referrer.indexOf(location.origin) === 0;
      if (cameFromSite && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = ROOT + 'collections/all';
      }
    });
  }
})();
